import { HomeNav } from "./HomeNav";

type StandardNavigationProps = {
  pathname?: string;
  openModal: (modalId: string) => void;
};

const StandardNavigation: React.FC<StandardNavigationProps> = ({
  pathname,
  openModal,
}) => {
  if (pathname !== "/screensaver") {
    return <HomeNav openModal={openModal} />;
  }
  return null;
};

export default StandardNavigation;
